import { createAction } from '../../../core/helpers'

import { COMMON_FETCH_COURSE_TYPES } from '../action-types'

const cleanupCommonFetchCourseTypes = createAction(
  COMMON_FETCH_COURSE_TYPES.CLEANUP,
)

export default cleanupCommonFetchCourseTypes
